import { Trans, useLingui } from '@lingui/react/macro';

import { CardItem, CardItems } from '@/components/Card/Card';
import { Body, Cell, Column, Header, Row, Table } from '@/design_system/Table/Table';
import { ArticleWithRelations } from '@/models/request';

import { DefectName } from './DefectName';

export const NotedDefectsTable = ({ article }: { article: ArticleWithRelations }) => {
  const { t } = useLingui();

  return (
    <Table
      theme="brand"
      ariaLabel={t({ id: 'client.article.defects', message: 'Noted defects' })}
      columnWidths={['100%']}
      bordered
    >
      <Header>
        <Row>
          <Column>
            <Trans id="client.article.defects">Noted defects</Trans>
          </Column>
        </Row>
      </Header>
      <Body>
        {article.snapshot.articleDefects.map((defect) => (
          <Row key={defect.id}>
            <Cell>
              <DefectName defect={defect} article={article} />
            </Cell>
          </Row>
        ))}
      </Body>
    </Table>
  );
};

export const NotedDefectsCards = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <CardItems>
      {article.snapshot.articleDefects.map((defect) => (
        <CardItem key={defect.id}>
          <DefectName defect={defect} article={article} />
        </CardItem>
      ))}
    </CardItems>
  );
};
